import React from 'react';
import { AlertTriangleIcon, InfoIcon, OctagonAlertIcon } from 'lucide-react';
import { watchItems } from '../data/plan';
const SEVERITY = {
  blocked: {
    icon: OctagonAlertIcon,
    color: 'text-alert',
    label: 'Blocked'
  },
  flag: {
    icon: AlertTriangleIcon,
    color: 'text-campaign',
    label: 'Flag'
  },
  note: {
    icon: InfoIcon,
    color: 'text-productc',
    label: 'Note'
  }
} as const;
export function WatchList() {
  return <ul className="divide-y divide-ink-700/70" data-id="element-131" data-mp="mn8qzeak18wr">
      {watchItems.map(item => {
      const s = SEVERITY[item.severity];
      const Icon = s.icon;
      return <li key={item.title} className="flex gap-3 py-3 first:pt-0 last:pb-0" data-id="element-132" data-mp="dlrb9x12798l">
            <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${s.color}`} aria-hidden="true" data-id="element-133" data-mp="ikkgl266ztxo" />
            <div data-id="element-134" data-mp="imf3gm10xw4e">
              <p className="text-[13px] font-medium text-chalk" data-id="element-135" data-mp="2ybzyp05iw72n">
                {item.title}
                <span className="sr-only" data-id="element-136" data-mp="33ateiz8a8a5z"> — {s.label}</span>
              </p>
              <p className="mt-1 text-xs leading-relaxed text-mute" data-id="element-137" data-mp="338qernhbv2o2">{item.detail}</p>
            </div>
          </li>;
    })}
    </ul>;
}